import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["classes", "overrides", "className", "options", "value", "isReadOnly", "onBlur", "onChange"];
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import RadioBoxControl from './RadioBoxControl';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
var useStyles = createUseStyles(styles, 'RadioBoxGroup');
var RadioBoxGroup = function RadioBoxGroup(_ref) {
  var classesProp = _ref.classes,
    overridesProp = _ref.overrides,
    classNameProp = _ref.className,
    options = _ref.options,
    value = _ref.value,
    isReadOnly = _ref.isReadOnly,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  // Overrides
  var override = getOverrides(overridesProp, RadioBoxGroup.overrides);

  // Classes
  var rootClassName = classnames(classes.root, _defineProperty({}, classes.isReadOnly, isReadOnly), classNameProp);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: rootClassName
  }, override.root), options.map(function (option) {
    return /*#__PURE__*/React.createElement(RadioBoxControl, _extends({
      key: option.value,
      overrides: overridesProp,
      isReadOnly: isReadOnly,
      option: option,
      value: value,
      onChange: onChange,
      onBlur: onBlur
    }, props));
  }));
};
RadioBoxGroup.overrides = ['root', 'RadioBox', 'radioBoxControl'];
RadioBoxGroup.defaultProps = {
  onChange: function onChange() {},
  value: null,
  options: [],
  isReadOnly: false,
  overrides: {}
};
process.env.NODE_ENV !== "production" ? RadioBoxGroup.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    value: PropTypes.string
  })),
  value: PropTypes.string,
  isReadOnly: PropTypes.bool
} : void 0;
export default /*#__PURE__*/memo(RadioBoxGroup);